import Cookies from 'js-cookie'

class Cookie
{
    cookieName = "geoeiendom"
    authenticationCookieName = "geoeiendomtoken"

    getProperty = (propertyName) => {
        var clientSettingsCookie = Cookies.get(this.cookieName)
        if (clientSettingsCookie == null) return null;
        var clientSettings = JSON.parse(clientSettingsCookie)
        return clientSettings[propertyName]
    }

    setProperty = (propertyName, value) => {
        var clientSettingsCookie = Cookies.get(this.cookieName)

        var clientSettings = {}
        if (clientSettingsCookie != null) clientSettings = JSON.parse(clientSettingsCookie)
        clientSettings[propertyName] = value
        
        Cookies.set(this.cookieName, JSON.stringify(clientSettings), { expires: 360 })
    }

    getAuthenticationCookie = () => {
        return Cookies.get(this.authenticationCookieName)
    }

    removeAuthenticationCookie = () => {
        Cookies.remove(this.authenticationCookieName)
    }

    setAuthenticationCookie = (tokenInfo, expirationInMinutes) => {
        Cookies.set(this.authenticationCookieName, JSON.stringify(tokenInfo), { expires: new Date(new Date().getTime() + expirationInMinutes*60*1000), secure: true })
    }
}

export default new Cookie()